let BASEURL;
let SHOW_PRICING = false;

if (
  window.location.hostname === "settlrs.com" ||
  window.location.hostname === "www.settlrs.com"
) {
  // Load production environment variables
  BASEURL = process.env.REACT_APP_API_ENDPOINT_PROD;
  SHOW_PRICING = false;
} else {
  // Load development environment variables
  BASEURL = process.env.REACT_APP_API_ENDPOINT_DEV;
  SHOW_PRICING = true;
}

export { BASEURL, SHOW_PRICING };
